import { ErrorMessage, Field } from '@atlaskit/form';
import Select, { OptionsType, ValueType } from '@atlaskit/select';
import React from 'react';
import { FinanceReasonCodeSelect } from '@atlassian/cssxp-types-billing';

interface Props {
  fieldName?: string;
  fieldLabel?: string;
  isRequired?: boolean;
  options: OptionsType<FinanceReasonCodeSelect>;
  isDisabled?: boolean;
}

export const InvoiceFinanceRefundReasonFormField = ({
  fieldName = 'financeRefundReason',
  fieldLabel = 'Finance refund reason',
  isRequired = true,
  options,
  isDisabled = false,
}: Props) => {
  return (
    <>
      <Field<ValueType<FinanceReasonCodeSelect>>
        name={fieldName}
        label={fieldLabel}
        isRequired={isRequired}
        validate={(value: any) => {
          return !value ? 'EMPTY' : undefined;
        }}
        defaultValue={options.length === 1 ? options[0] : null}
        isDisabled={isDisabled}
      >
        {({ fieldProps, error }) => (
          <div data-testid="finance-refund-reason-field">
            <Select<FinanceReasonCodeSelect>
              {...fieldProps}
              id={fieldProps.id}
              className="refund-reason-field"
              classNamePrefix="refund-reason-each-field"
              spacing="compact"
              isSearchable={false}
              options={options}
              placeholder="Select the finance reason for this refund"
              validationState={error ? 'error' : 'default'}
            />
            {error && <ErrorMessage>Please select the reason for finance refund</ErrorMessage>}
          </div>
        )}
      </Field>
    </>
  );
};
